const path = '/user';

export const userRoutes = {
  ROOT: {
    get rule() {
      return path;
    },
    get make() {
      return () => this.rule;
    },
  },
  ACCOUNT_SETTINGS: {
    get rule() {
      return `${path}/account-settings`;
    },
    get make() {
      return () => this.rule;
    },
  },
};
